export const HTTP_PROTOCOL = "https://";
export const API_KEY = process.env.REACT_APP_OT;
export const API_ROOT_URL =`${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_API_URL}`;
export const logger = process.env.REACT_APP_LOGGER_ENABLE;
export const PatientDesiredRole = 1;
export const CounsellorDesiredRole = 0;
export const paypalClientId = process.env.REACT_APP_PAYPAL_CLIENT_ID
export const enableGA=process.env.REACT_APP_GA_ENABLE;
export const Counsellor_Portal_URL = process.env.REACT_APP_COUNCELLOR_PORTAL;
export const Sub_Domain= process.env.REACT_APP_SUBDOMAIN;
export const enable_Bugsnag= process.env.REACT_APP_ENABLE_BUGSNAG;
export const bugsnag_APIKEY = process.env.REACT_APP_BUGSNAG_APIKEY;

// Setting whitelabel for counsellor
export const whitelabelObj = [
	{
		id: '2465a1f1-36eb-48a7-8b5b-232cf3dfd3cb',
		name: 'Counsellor',
		domain: 'iba.edu.pk',
		sys_domain: 'counsellor.saayahealth.com',
		sub_domain: 'councellor',
		logo_url: 'https://dev-api.saayahealther.com/media/logo/Saaya_Logo_Final-1_omIYDeI.svg',
		email_domain: "['all']",
		app_version: '2.0.0',
		date_created: '2020-03-26T07:10:13.891414Z',
		date_modified: '2020-04-13T11:58:49.915539Z',
		consumer_role: 'client',
		payment_required: false,
		producer_role: 'counsellor',
		slot_threshold: '24',
	},
];

// const production = "https://api.saayahealth.com";
// const development = "https://dev.saayahealth.com:8000";
// const ot_production = "46193362";
// const ot_developement = "46266622";

// const hostname = window && window.location && window.location.hostname;

// if (hostname === "dev.saayahealth.com") {
//   backendHost = development;
//   ot_key = ot_developement;
//   logger_enable = false;
// } else if (hostname.toLowerCase() === "iba.saayahealth.com" || hostname.toLowerCase() === "pakqatar.saayahealth.com") {
//   backendHost = production;
//   ot_key = ot_production;
//   logger_enable = false;
// } else {
//   backendHost = development;
//   ot_key = ot_developement;
//   logger_enable = true;
// }



// WEBPACK FOOTER //
// ./src/config.js